import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
<footer className="w-full bg-gradient-to-r from-[#2E2E2E] to-[#1B1464] text-white shadow-lg border-t border-gray-700">
  <div className="max-w-screen-xl mx-auto px-6 py-1 md:flex md:items-center md:justify-between">
    {/* الحقوق */}
    <span className="block text-sm text-gray-300 sm:text-center">
      © {new Date().getFullYear()}{" "}
      <Link
        to="/"
        className="font-semibold text-yellow-400 hover:text-yellow-300 transition-colors duration-300"
      >
        DTEC
      </Link>
      . All Rights Reserved.
    </span>

    {/* روابط */}
    <ul className="flex flex-wrap items-center mt-1 text-sm font-medium sm:mt-0 gap-4">
      <li>
        <Link
          to="mailto:info@dtec-eg.com"
          className="text-gray-300 hover:text-yellow-400 transition-colors duration-300"
        >
          info@dtec-eg.com
        </Link>
      </li>
      {/* <li>
        <Link
          to="/contact"
          className="text-gray-300 hover:text-yellow-400 transition-colors duration-300"
        >
          Contact Us
        </Link>
      </li> */}
    </ul>
  </div>
</footer>

  );
};

export default Footer;
